import { FC } from "react";
import {
  ShieldCheckIcon,
  TruckIcon,
  GlobeAltIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";

const features = [
  {
    icon: ShieldCheckIcon,
    title: "Durable",
    desc: "UK-engineered profiles built to last in demanding environments.",
  },
  {
    icon: TruckIcon,
    title: "Fast Delivery",
    desc: "Largest stock in Dubai with same-day dispatch available.",
  },
  {
    icon: GlobeAltIcon,
    title: "Global Reach",
    desc: "Serving UAE, Bahrain, Kuwait, Qatar, Oman & Saudi Arabia.",
  },
  {
    icon: CurrencyDollarIcon,
    title: "Affordable Pricing",
    desc: "Competitive rates without compromising on quality.",
  },
];

const SectionWhyChooseUs: FC = () => {
  return (
    <section id="why-choose-us" className="py-12 sm:py-16 lg:py-20 bg-white dark:bg-neutral-900 scroll-mt-16">
      <div className="container px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-neutral-900 dark:text-white mb-8 sm:mb-12">
          Why Choose Us
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {features.map((f) => (
            <div
              key={f.title}
              className="text-center p-4 sm:p-6 rounded-2xl hover:shadow-bcr-card transition-shadow duration-300"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 mx-auto rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-3 sm:mb-4">
                <f.icon className="w-6 h-6 sm:w-7 sm:h-7 text-amber-600 dark:text-amber-400" />
              </div>
              <h3 className="font-bold text-sm sm:text-base text-neutral-900 dark:text-white">
                {f.title}
              </h3>
              <p className="mt-1.5 text-xs sm:text-sm text-neutral-500 dark:text-neutral-400 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionWhyChooseUs;
